import { safetyTips } from '@/mocks/categories';

export default function SafetySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">Safety Center</span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Is Vigorbuy Spreadsheet Safe?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            We take safety seriously. Here are the essential tips to ensure you have a secure and informed experience when using the Vigorbuy Spreadsheet and navigating to external product links.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {safetyTips.map((tip) => (
            <div key={tip.check} className="p-6 rounded-2xl bg-white border border-background-200">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-accent-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-2">{tip.check}</h4>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{tip.recommendation}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 rounded-2xl bg-accent-50 border border-accent-200">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-1">Important Disclaimer</h4>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                Vigorbuy Spreadsheet is an independent informational resource. We organize and present product links for discovery purposes but do not process transactions, handle payments, or guarantee third-party product quality. Always verify the destination website and exercise caution when making purchases on external platforms.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}